import type { ReactNode } from 'react';
import { useViewport } from './useViewport';

/** Dialog giữa màn hình; trên điện thoại thành bottom-sheet bám đáy, rộng hết màn. */
export function WebModal({ onClose, width = 520, children }: { onClose?: () => void; width?: number; children?: ReactNode }) {
  const { phone } = useViewport();
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 45,
        display: 'flex',
        alignItems: phone ? 'flex-end' : 'center',
        justifyContent: 'center',
        padding: phone ? 0 : 24,
        fontFamily: 'var(--font-vi)',
      }}
    >
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(1,31,75,0.45)', backdropFilter: 'blur(2px)' }} />
      <div
        style={{
          position: 'relative',
          width: '100%',
          maxWidth: width,
          maxHeight: phone ? '92dvh' : '88vh',
          background: 'var(--surface-page)',
          borderRadius: phone ? 'var(--radius-card) var(--radius-card) 0 0' : 'var(--radius-card)',
          paddingBottom: phone ? 'env(safe-area-inset-bottom, 0px)' : 0,
          boxShadow: 'var(--shadow-raised)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </div>
    </div>
  );
}
